export default __webpack_public_path__ + "static/media/heineken-logo-white.53283ee5.png";